import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LSHelper } from '@crm-framework/utils';

interface ILayoutState {
  isCollapsedSidebar: boolean;
  sidebarWidth?: number;
  mainDashboardName?: string;
}

const LAYOUTS_STORAGE_KEY = '@layouts';

const savedState = LSHelper.getObject<ILayoutState>(LAYOUTS_STORAGE_KEY);

const initialState: ILayoutState = {
  isCollapsedSidebar: false,
  ...savedState,
  mainDashboardName: undefined,
};

const store = createSlice({
  name: LAYOUTS_STORAGE_KEY,
  initialState,
  reducers: {
    toggleSidebar: {
      reducer(
        state,
        {
          payload,
        }: PayloadAction<{
          collapsed: boolean;
          isUserAction: boolean;
        }>
      ) {
        state.isCollapsedSidebar = payload.collapsed;
      },
      prepare(collapsed: boolean, isUserAction: boolean = false) {
        return {
          payload: { isUserAction, collapsed },
        };
      },
    },
    // TODO: Change payload type from sidebar callback type
    updateSidebarState: {
      reducer(
        state,
        {
          payload,
        }: PayloadAction<{
          width: number;
          collapsed: boolean;
          isUserAction: boolean;
        }>
      ) {
        state.isCollapsedSidebar = payload.collapsed;
        state.sidebarWidth = payload.width;

        if (payload.isUserAction) {
          LSHelper.setItem(LAYOUTS_STORAGE_KEY, state);
        }
      },
      prepare(
        state: {
          width: number;
          collapsed: boolean;
        },
        isUserAction: boolean = false
      ) {
        return {
          payload: { ...state, isUserAction },
        };
      },
    },
    setMainDashboardName: (state, { payload }: PayloadAction<string>) => {
      state.mainDashboardName = payload;
    },
  },
});

export interface IStoreWithLayouts {
  layouts: ILayoutState;
}

export const layoutsActions = store.actions;

export const layoutsReducer = store.reducer;
